export default __webpack_public_path__ + "static/media/universe.3048ef10.png";